export default __webpack_public_path__ + "static/media/dreamstime_s_22464803.131b397b.jpg";